import { Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { calculateAdvancement } from "../../utils/calculateAdvancement";

function handleMoveKanbanTaskRequest(
  task: Identifiable<Task>,
  { nextColumn, task: t }: Boundaries["moveKanbanTask"]["request"],
): Identifiable<Task> {
  return t.uuid === task.uuid
    ? calculateAdvancement({
        ...task,
        completionDate:
          t.completionDate !== task.completionDate
            ? t.completionDate
            : task.completionDate,
        status: nextColumn.status,
        allocations: task.allocations.map((allocation) => ({
          ...allocation,
          percentComplete:
            nextColumn.status.percentComplete !== undefined
              ? nextColumn.status.percentComplete
              : allocation.percentComplete,
        })),
      })
    : task;
}

function handleMoveKanbanTaskSuccess(
  task: Identifiable<Task>,
  { nextColumn, task: t }: Boundaries["moveKanbanTask"]["success"],
): Identifiable<Task> {
  return t.uuid === task.uuid
    ? calculateAdvancement({
        ...task,
        completionDate:
          t.completionDate !== task.completionDate
            ? t.completionDate
            : task.completionDate,
        status: nextColumn.status,
        allocations: task.allocations.map((allocation) => ({
          ...allocation,
          percentComplete:
            nextColumn.status.percentComplete !== undefined
              ? nextColumn.status.percentComplete
              : allocation.percentComplete,
        })),
      })
    : task;
}

function handleMoveKanbanTaskFailure(
  task: Identifiable<Task>,
  { task: t }: Boundaries["moveKanbanTask"]["failure"],
): Identifiable<Task> {
  return t.uuid === task.uuid ? t : task;
}

export {
  handleMoveKanbanTaskRequest,
  handleMoveKanbanTaskSuccess,
  handleMoveKanbanTaskFailure,
};
